<template>
  <div class="box">
    <div class="sub-top c-f-ar" v-if="fromPage !== 'handCardPay'">
      <!-- <van-count-down
        :time="countTime2"
        format="HH:mm:ss"
      /> -->
      <div class="c-f">
        <div class="c-m-r-20">剩余支付时间</div>
        <div>
          <van-count-down :time="countTime" format="HH:mm:ss" />
        </div>
      </div>
    </div>
    <div class="top c-ct">
      <template v-if="fromPage != 'point'">
        <span class="prefix">￥</span>{{ this.order.OrigMoney }}
      </template>
      <span v-else
        >{{ this.order.OrigMoney }}<span class="prefix">积分</span></span
      >
    </div>
    <div class="c-p-30 b-r-12" v-if="fromPage != 'point'">
      <van-radio-group v-model="radio" @change="handleChangePayType">
        <van-cell title="微信支付">
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template #icon>
            <g-img2 src="wx_icon.png" class="l-img"></g-img2>
          </template>
          <template #right-icon>
            <!-- <g-img
            :src="require('@/assets/images/checked3.png')"
            class="l-img"
            :size="40"
          ></g-img> -->
            <van-radio name="wechat">
              <template #icon="props">
                <img
                  style="width: 20px"
                  :src="props.checked ? activeIcon : inactiveIcon"
                />
              </template>
            </van-radio>
          </template>
        </van-cell>

        <van-cell v-if="fromPage !== 'flash'&&fromPage !== 'food'">
          <!-- 使用 right-icon 插槽来自定义右侧图标 -->
          <template>
            <div>
              <span>会员卡支付</span>
              <span v-if="memberArr.length == 0" class="c-sub-txt">/暂无</span>
            </div>
          </template>
          <template #icon>
            <g-img2 class="l-img" src="mcpay"></g-img2>
          </template>
          <template #extra>
            <div class="c-tc" @click="bindRealCard">绑定实体卡</div>
          </template>
        </van-cell>

        <member-list
          v-if="fromPage !== 'food'"
          class="p-tb-10 p-lr-35"
          :list="memberArr"
          :payPrice="amount"
          @click="getSelectMemberList"
        ></member-list>
      </van-radio-group>
      <div class="f-bt bg-white" style="padding: 10px 16px">
        <div class="coupon_use_left">
          <g-img2 class="l-img" src="coupon_icon"></g-img2>
          <span>优惠券</span>
        </div>
        <div
          v-if="couponList.length > 0"
          class="can_use_right"
          @click="handleShowCouponPopup"
        >
          <span class="can_use_num" v-if="selectCoupons.length <= 0"
            >{{ couponList.length }}张优惠券可用</span
          >
          <span class="can_use_num" v-else
            >已选{{ selectCoupons.length }}张优惠券</span
          >

          <i class="iconfont icon-xiangyou"></i>
        </div>
        <div v-else class="c-lightgrey">无可用优惠券</div>
      </div>
    </div>

    <nonSecretPay
      :show.sync="memberPayShow"
      :list="selectMemberList"
      :orderId ='orderId'
      :recAmount="order.OrigMoney"
      @paySuccess="memberPaySuccess"
    ></nonSecretPay>

    <!-- <van-field
      v-model="selectedCouponName"
      is-link
      label="可用优惠券"
      :placeholder="selectedCouponPlaceHolder"
      @focus="onCouponFocus"
      input-align="right"
    /> -->
    <van-popup
      class="coupon_pop_con"
      round
      v-model="couponPopupShow"
      position="bottom"
    >
      <div class="coupon_dialog_con my-white-box">
        <div class="cartTitle">
          <span> 优惠券 </span>
          <div class="clear" @click="closeCouponPop">
            <van-icon name="close" size="17" />
          </div>
        </div>
        <div class="coupon_list_scroll">
          <div
            v-for="(v, i) in couponList"
            :key="i"
            class="coupon_list_item"
            @click="handleSelectCoupon(v)"
          >
            <div class="coupon_list_left">
              <div class="left_con p-lr-26">
                <div>
                  <div class="">
                    <span
                      class="coupon_type_con"
                      :style="{
                        background: v.IsCoupon ? '#03cc66' : '#ff5c10',
                      }"
                      >{{ v.IsCoupon ? "优惠券" : "票券" }}</span
                    >
                    <span class="c-ft-32">{{ v.TicketName }}</span>
                  </div>

                  <p v-if="v.IsExclusive" class="c-lightgrey c-m-t-10 c-ft-26">
                    此券不可与其他优惠券叠加使用
                  </p>
                </div>
                <div class="m-b-10 c-ft-24" :style="{ color: '#999' }">
                  <span>{{ v.UseStartDate }} 至 {{ v.UseEndDate }}</span>
                </div>
                <div class="circle"></div>
                <div class="circle2"></div>
              </div>
            </div>

            <div
              class="right_con p-lr-10 p-tb-24 c-fc-center h-block"
              :style="{
                'justify-content': 'space-between',
              }"
            >
              <div class="">
                <div class="money" v-if="v.CostPrice > 0 || v.Price > 0">
                  <span>￥</span>
                  <span>{{ v.CostPrice || v.Price }}</span>
                </div>
              </div>

              <div>
                <i
                  :class="
                    v.isCheck
                      ? 'iconfont icon-yuanxingxuanzhongfill check_icon'
                      : 'iconfont icon-yuanxingweixuanzhong un_check_icon'
                  "
                >
                </i>
              </div>
            </div>
          </div>
        </div>
        <div class="cart_footer">
          <van-button color="var(--tc)" round block @click="handleSubmitCoupon"
            >确定</van-button
          >
        </div>
      </div>
    </van-popup>
    <van-action-sheet
      v-model="showCoupons"
      :round="false"
      :actions="coupons"
      @select="onSelect"
    />
    <div class="c-btm-box">
      <van-button color="var(--tc)" round block @click="confirmPay"
        >确认支付</van-button
      >
    </div>
    <!-- <g-bottom-btn @click="confirmPay" title="确认支付"></g-bottom-btn> -->
  </div>
</template>

<script>
import {
  getOrderDetail,
  getGoodOrderDetail,
} from "@/api/order";
import { getCardConsumeMoney } from "@/api/scan.js";

import { getPayCouponList } from "@/api/coupon";
import { sqbWxPay, sqbH5Pay } from "@/api/pay";
import nonSecretPay from "./comps/nonSecretPay";
import memberList from "./comps/memberList.vue";
import wxConfig from "@/utils/wxConfig.js";
import {
  handleTimeLocalStorage,
  handleSessionStorage,
  handleLocalStorage,
} from "@/utils";
import { wechatPay } from '@/utils/gFunc';
export default {
  name: "PayList",
  props: {},
  components: {
    nonSecretPay,
    memberList,
  },
  data() {
    return {
      activeIcon: require("@/assets/radio/radio-active.png"),
      inactiveIcon: require("@/assets/radio/radio-unactive.png"),
      radio: "wechat",
      memberPayShow: false,
      orderId: this.$route.query.id,
      sequenceId: this.$route.query.SequenceId,
      countTime2: 233583,
      orderDetails: [],
      amount: 0,
      originalAmount: null,
      selectedCouponPlaceHolder: "无", // 可用优惠券
      coupons: [],
      selectedId: null,
      minusAmount: null,
      payWay: 3, // 支付方式，3：微信，1：支付宝
      isWeChatClient: true,
      showCoupons: false,
      selectedCouponTypeId: null,
      selectedCouponName: null,
      goodsInfo: this.$pub.getS("goodsInfo"),
      order: { OrigMoney: 0 },
      memberArr: [],
      selectMemberList: {},
      globalReturnUrl: "",
      countTime: "",
      couponPopupShow: false,
      selectCoupons: [],
      couponList: [],
    };
  },
  created() {
    const queryData = this.$route.query;
    this.fromPage = queryData.fromPage;


    if (this.fromPage == "food") {
       this.orderId = queryData.id
       this.sequenceId = queryData.SequenceId
      this.handleGetFoodInfo();
    } else if (this.fromPage == "handCardPay") {
      this.order.OrigMoney = queryData.priceData;
      this.sequenceId = queryData.sequenceId;
      this.amount = queryData.priceData;
    } else {
      this.init();
    }
    // 抢购仅可微信支付
    if (this.fromPage !== "flash") {
      this.getMemberList();
    }
    this.getCouponList();
    wxConfig.getWxParameter(this)
  },
  mounted() {},
  methods: {
    getSelectMemberList(sendList) {
      this.selectMemberList = sendList;
      if (this.fromPage == "handCardPay") {
        this.handleGetCardConsumeMoney();
      }
    },
    handleGetCardConsumeMoney(flag) {
      const preSettleConsumeList =
        handleTimeLocalStorage.get("settleConsumeList");
      const param = {
        OrderId: this.orderId,
        ConsumeViewModelList: preSettleConsumeList,
      };
      if (this.radio != "wechat" && this.selectMemberList.Id) {
        param.MemberPayments = [
          {
            MemberId: this.selectMemberList.Id,
            ConsumeMoney: this.order.OrigMoney,
            CardTypeId: this.selectMemberList.CardTypeId,
            RowVersion: this.selectMemberList.RowVersion,
            CardCode: this.selectMemberList.CardCode,
          },
        ];
      }
      let preSelectCoupons = [];
      if (flag == "modal") {
        let preSelect = [];
        this.couponList.forEach((item) => {
          if (item.isCheck) {
            preSelect.push(this.$pub.deepClone(item));
          }
        });
        preSelectCoupons = preSelect;
      } else {
        preSelectCoupons = this.selectCoupons;
      }
      if (preSelectCoupons.length > 0) {
        let saasCouponArr = [],
          wechatCouponArr = [];
        preSelectCoupons.forEach((cItem) => {
          if (cItem.CouponId) {
            saasCouponArr.push({
              EntryId: cItem.Id,
              CouponId: cItem.CouponId,
              CouponNumber: cItem.TicketCode,
              Money: cItem.Price,
              ItemName: cItem.TicketName,
              CouponName: cItem.TicketName,
            });
          } else {
            wechatCouponArr.push({
              CoopMerchantId: cItem.CoopMerchantId,
              CouponNumber: cItem.TicketCode,
            });
          }
        });
        param.GroupCouponPayments = wechatCouponArr;
        param.CouponPayments = saasCouponArr;
      }

      getCardConsumeMoney(param)
        .then((res) => {
          console.log(res);
          this.$set(this.order, "OrigMoney", res.WaitPayMoney);
          // this.order.OrigMoney = res.WaitPayMoney;
        })
        .catch((err) => {
          // uni.hideLoading();
          console.log(err);
          // 票券不可用时，将最后勾选的优惠券取消勾选
          if (this.lastClickCoupon) {
            this.couponList.forEach((item) => {
              if (item.isCheck && item.Id == this.lastClickCoupon.Id) {
                item.isCheck = false;
              }
            });
            this.lastClickCoupon = null;
          }
        });
    },
    handleChangePayType(value) {
      console.log(value);
      console.log(this.radio);
      if (this.fromPage == "handCardPay" && this.radio == "wechat") {
        this.handleGetCardConsumeMoney();
      }
    },
    getMemberList() {
      const params = {
        IsBindWx: true,
        VpnId: this.$store.state.vpnId,
      };
      $http("wechath5/zh-cn/v1/member/list", params, "get").then((res) => {
        this.memberArr = res;
      });
    },
    async init() {
      const orders = await getOrderDetail({ query: { id: this.orderId } });
      this.order = orders.Items[0];
      this.countTime = $pub.strToTime(this.order.LastConfirmTime) - new Date().getTime();
      this.globalReturnUrl =
        location.href.split("#")[0] + "#/consumecode-detail/" + this.orderId;
      this.sequenceId = this.order.SequenceId;
      this.orderDetails = this.order.Details;
      this.amount = this.order.OrigMoney;
      this.originalAmount = this.order.OrigMoney;
      // const couponItems = await getPayCouponList({
      //   query: {
      //     Status: 0,
      //     ProductIds: this.order.Details.map((m) => m.ProductId),
      //     IsLimitCurrentDay: true,
      //     Amount: this.originalAmount,
      //   },
      //   Pager: { PageSize: 1000 },
      // });

      // if (couponItems && couponItems.Items && couponItems.Items.length > 0) {
      //   this.selectedCouponPlaceHolder = "选择 ";
      //   this.coupons.push({ name: "", value: "", subname: "不选择优惠券" });
      //   couponItems.Items.map((m) => {
      //     let subname = "";
      //     if (m.CouponRuleType.Id === 0) {
      //       subname = `满${m.CouponPrice}减${m.CouponSale}`;
      //     } else if (m.CouponRuleType.Id === 1) {
      //       let count = m.CouponSale.toString();
      //       if (count.length > 1 && count.substr(1, 1) == "0") {
      //         count = count.substr(0, 1);
      //       }
      //       subname = `满${m.CouponPrice}打${count}折`;
      //     }
      //     this.coupons.push({
      //       name: `${m.CouponName}(${m.CouponNumber})`,
      //       value: m.Id,
      //       subname: subname,
      //       typeid: m.CouponType.Id,
      //       ruletypeid: m.CouponRuleType.Id,
      //       price: m.CouponPrice,
      //       sale: m.CouponSale,
      //     });
      //   });
      // }
    },
    //获取餐品订单详情
    async handleGetFoodInfo() {
      const orders = await getGoodOrderDetail({ id: this.orderId });
      this.order = orders;
      this.countTime =  $pub.strToTime(this.order.LastConfirmTime) - new Date().getTime();
      this.sequenceId = this.order.SequenceId;
      this.amount = this.order.OrigMoney;
      this.originalAmount = this.order.OrigMoney;


    },
    getCouponList() {
      let sendParams = {
        orderId: this.orderId,
      };
      getPayCouponList(sendParams).then((res) => {
        res.forEach((v) => {
          v.UseEndDate = v.UseEndDate.split(" ")[0];
          v.UseStartDate = v.UseStartDate.split(" ")[0];
          v.isCheck = false;
        });
        this.couponList = res;
      });
    },
    handleShowCouponPopup() {
      this.couponPopupShow = true;
      console.log(this.selectCoupons);
      this.couponList.forEach((item) => {
        const findItem = this.selectCoupons.find(
          (sItem) => sItem.Id == item.Id
        );
        if (findItem) {
          item.isCheck = findItem.isCheck;
        } else {
          item.isCheck = false;
        }
      });
    },
    handleSubmitCoupon() {
      this.couponPopupShow = false;

      let preSelect = [];
      this.couponList.forEach((item) => {
        if (item.isCheck) {
          preSelect.push(this.$pub.deepClone(item));
        }
      });
      this.selectCoupons = preSelect;
      //选择优惠券后， 自助结账场景时需要重新调用结算接口
      if (this.fromPage == "handCardPay") {
        this.handleGetCardConsumeMoney();
      }
    },
    closeCouponPop() {
      this.couponPopupShow = false;
    },
    handleSelectCoupon(v) {
      if (v.isCheck) {
        v.isCheck = !v.isCheck;
      } else {
        if (v.IsExclusive) {
          //票券独占时
          let hasSelect = false;
          this.couponList.forEach((item) => {
            if (item.isCheck) {
              hasSelect = true;
              item.isCheck = false;
            }
          });
          // if (hasSelect) {
          //   this.$toast(
          //     "此券不可与其他优惠券叠加使用,已自动取消勾选其他优惠券"
          //   );
          // }
          this.lastClickCoupon = v;
          v.isCheck = true;
        } else {
          //不独占时
          // 先清除所有独占券的选中状态
          this.couponList.forEach((item) => {
            if (item.IsExclusive) item.isCheck = false;
          });
          if (v.UseNumber) {
            //限制同种券可用数量时
            let sameNum = 0;
            this.couponList.forEach((item) => {
              if (item.isCheck && item.TicketCode == v.TicketCode) {
                sameNum++;
              }
            });
            if (sameNum >= v.UseNumber) {
              this.$toast("每笔订单最多同时使用" + v.UseNumber + "张此优惠券");
            } else {
              this.lastClickCoupon = v;
              v.isCheck = true;
            }
          } else {
            this.lastClickCoupon = v;
            v.isCheck = true;
          }
        }
        //选择优惠券后， 自助结账场景时需要重新调用结算接口
        if (this.fromPage == "handCardPay") {
          this.handleGetCardConsumeMoney("modal");
        }
      }
    },

    async confirmPay() {
      // this.$router.push({
      //   name: "CollageSubmission",
      //   query: { id: this.orderId, fromPage: "goodsmall" },
      // });
      // 这是收钱吧支付
      /*  let param = {
         OrderId: this.orderId,
         PayDetails: [{
           PayMethodTypeId: 0,      //wechat
           PayMethodId: null,
           Receipts: this.amount
         }]
       }
       if (this.selectedId) {
         param.PayDetails.push({
           PayMethodTypeId: this.selectedCouponTypeId,
           PayMethodId: this.selectedId,
           Receipts: this.minusAmount
         })
       }
       const result = await payOrder(param)
       if (result) {
         // 回调H5支付接口
         this.onPay(this.sequenceId, this.orderId)
       } */
      if (this.fromPage == "point") {
        // 此处调用扣除会员卡积分接口
        // handleLocalStorage.set("orderId", "54839707");
        this.$router.replace({ name: "CollageSubmission" });
      } else {
        if (this.radio === "wechat") {
          const vpnInfo = handleSessionStorage.get("vpnInfo");
          await wechatPay(
            this.sequenceId,
            this.amount * 100,
            this.fromPage == "food"
              ? {
                  payAfterUrl: "PlaceOrderSuccess",
                  sqbAfterUrl: "payResult",
                  orderId: this.orderId,
                  payType: vpnInfo.WechatPayChannel,
                  vpnCode: vpnInfo ? vpnInfo.code : "",
						    	GroupCouponPayments: this.selectCoupons
                }
              : this.fromPage == "goodsmall" || this.fromPage == "flash"
              ? {
                  payAfterUrl: "CollageSubmission",
                  sqbAfterUrl: "CollageSubmission",
                  orderId: this.orderId,
                  vpnCode: vpnInfo ? vpnInfo.code : "",
						    	GroupCouponPayments: this.selectCoupons
                }
              : this.fromPage == "handCardPay"
              ? {
                  payAfterUrl: "CollageSubmission",
                  sqbAfterUrl: "CollageSubmission",
                  orderId: this.orderId,
                  vpnCode: vpnInfo ? vpnInfo.code : "",
						    	GroupCouponPayments: this.selectCoupons
                }
              : {
                  orderId: this.orderId,
                  vpnCode: vpnInfo ? vpnInfo.code : "",
						    	GroupCouponPayments: this.selectCoupons
                }
          );
        } else {
          this.memberPayShow = true;
        }
      }
    },
    // 会员卡支付
    memberPay() {
      let selectedMember = this.memberArr.filter((v) => {
        return v.Id === this.radio;
      })[0];
      let params = {
        OrderId: this.orderId,
				GroupCouponPayments: this.selectCouponCodes,
        MemberPayments: [
          {
            MemberId: selectedMember.Id,
            ConsumeMoney: this.order.OrigMoney,
            CardTypeId: selectedMember.CardTypeId,
            RowVersion: selectedMember.RowVersion,
            CardCode: selectedMember.CardCode,
            CardTypeName: selectedMember.CardTypeName,
          },
        ],
      };
      $http("wechath5/zh-cn/v1/member/pay", params, "post").then((res) => {

        
      });
    },
    // 支付
    onPay(sequenceId, orderId) {
      // let returnUrl = location.href.split('#')[0] + '#/users/users-order'
      // let returnUrl = location.href.split('#')[0] + '#/goods/order'
      // returnUrl = location.href.split('#')[0] + '#/consumecode-detail/' + orderId;
      let payRequest = "";
      let requestParams = {
        OutTradeNo: sequenceId,
        Subject: `金贵票务${orderId}`,
        Fee: Number(this.amount * 100),
        //Fee: Number(0.01 * 100),
        Payway: this.payWay,
        // UserId: this.userId,
        ReturnUri: this.globalReturnUrl,
        // ClientId: 2
      };
      if (this.isWeChatClient) {
        payRequest = sqbWxPay; // 微信内置浏览器环境下，调用收钱吧公众号支付
      } else {
        payRequest = sqbH5Pay; // 其他环境下调用收钱吧H5支付
        requestParams.SubPayway = 6;
        requestParams.UserIp = localStorage.getItem("Ip");
      }
      payRequest(requestParams)
        .then((res) => {
          if (res) {
            // 支付跳转链接
            this._paySuccessJump(res);
          }
        })
        .catch((err) => {});
    },
    memberPaySuccess() {
      this.$toast("会员卡支付成功");
      // location.href = this.globalReturnUrl;
      if (this.fromPage == "food") {
        this.$router.replace({ name: "PlaceOrderSuccess" });
      } else {
        handleLocalStorage.set("orderId", this.orderId);
        this.$router.replace({ name: "CollageSubmission" });
      }
    },
    _paySuccessJump(resParams) {
      if (this.isWeChatClient) {
        location.href = resParams;
      } else if (resParams.wap_pay_request.h5_pay_redirect_url) {
        location.href = `${
          resParams.wap_pay_request.h5_pay_redirect_url
        }&redirect_url=${encodeURIComponent(this.globalReturnUrl)}`;
      } else {
      }
    },
    bindRealCard() {
      this.$router.push("/member/bindRealCard");
    },
    onCouponFocus() {
      if (this.coupons.length === 0) return;
      this.showCoupons = true;
    },

    onSelect(item) {
      const { $calc } = this;
      this.showCoupons = false;
      this.selectedCouponTypeId = 1;
      this.selectedId = item.value;
      this.selectedCouponName = item.name;
      if (this.selectedId) {
        if (this.originalAmount >= item.price) {
          if (item.ruletypeid === 0) {
            this.minusAmount = item.sale;
            // this.amount = this.originalAmount - item.sale
            this.amount = $calc.subtract(this.originalAmount, item.sale);
          } else if (item.ruletypeid === 1) {
            // this.minusAmount = (100 - item.sale) / 100 * this.originalAmount
            // this.amount = item.sale / 100 * this.originalAmount
            let sub = $calc.subtract(100 - item.sale);
            this.minusAmount = $calc.divide(sub, 100 * this.originalAmount);
            this.amount = $calc.divide(item.sale, 100 * this.originalAmount);
          }
        }
      } else {
        this.minusAmount = null;
        this.amount = this.originalAmount;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  font-size: 28px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
}
.top {
  height: 66px;
  font-size: 48px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-bottom: 90px;
  padding-top: 50px;
}
.prefix {
  font-size: 30px;
}
.sub-top {
  margin-left: 50%;
  transform: translate(-50%);
  height: 36px;
  font-size: 26px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #666666;
  // margin-bottom: 20px;
  padding-top: 120px;
}
.wx-img {
  margin-right: 10px;
  object-fit: contain;
}
.l-img {
  margin-right: 20px;
}
.coupon_use_left {
  display: flex;
  align-items: center;
}
.can_use_right {
  .can_use_num {
    color: #cca568;
  }

  .iconfont {
    font-size: 24px;
  }
}
.coupon_dialog_con {
  border-radius: 30px 30px 0 0;

  .cartTitle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 90px;
    font-size: 28px;
    color: #333;
    font-weight: bold;

    .clear {
      height: 100%;
      display: flex;
      align-items: center;
      color: #999;
      font-size: 24px;
      font-weight: normal;

      // .van-icon {
      //   margin-right: 5rpx;
      // }
    }
  }

  .coupon_list_scroll {
    max-height: 600px;
    overflow: auto;
    background: #f7f7f7;
  }

  .cart_footer {
    padding: 20px 30px;
    box-shadow: inset 0px 1px 0px 0px rgba(222, 222, 222, 0.5);
  }
}

.coupon_list_item {
  display: flex;
  margin: 20px 26px;
  position: relative;

  &:last-child {
    margin-bottom: 0 !important;
  }

  .coupon_list_left {
    width: calc(100% - 210px);
    display: flex;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    // height: 200rpx;
    // margin: 10rpx 0;
    box-sizing: border-box;
    background: #fff;
    align-items: center;
    // padding-left: 20px;
  }
}

.left_con {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 30px 0;
  box-sizing: border-box;
  position: relative;
  border-right: 4px dashed #f7f7f7;
  .coupon_type_con {
    border-radius: 5px;
    font-size: 20px;

    color: #fff;
    vertical-align: 3px;
    margin-right: 5px;
    padding: 0 7px;
  }
  .circle {
    position: absolute;
    right: -16px;
    top: -15px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f7f7f7;
  }

  .circle2 {
    position: absolute;
    right: -16px;
    bottom: -15px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #f7f7f7;
  }
}

.right_con {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  background: #fff;
  height: 216px;
  width: 230px;
  padding: 20px 0;
  // right: 0;
  // top: -9rpx;
  // position: absolute;
  box-sizing: border-box;
  // background: url("../../assets/images/coupon-bg.png") no-repeat;
  // background-size: cover;
  // justify-content: space-between;

  .money {
    color: #c8465c;
    font-size: 42px;
  }

  .iconfont {
    font-size: 40px;
  }

  .check_icon {
    color: #cca568;
  }

  .un_check_icon {
    color: rgb(207, 207, 207);
  }
}
</style>
